// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import $ from 'jquery';
import myw from 'myWorld/base/core';
import helpHtml from 'text!html/help.htm';

myw.HelpPanel = myw.Control.extend({
    innerTemplate: _.template(helpHtml),

    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);

        this.$el.html(this.innerTemplate({ baseUrl: myw.baseUrl }));
        myw.translate('help', this.$el);

        this.$('#mywVersion').html(myw.version);

        this.app.system.getSchemaVersion().then(version => {
            this.$('#dbSchemaVersion').html(version);
        });

        this.setPanelHeight();

        $(window).resize(() => {
            this.setPanelHeight();
        });
    },

    /*
     * Sets the help panel height according to the window height
     */
    setPanelHeight() {
        const windowHeight = $(window).height();
        this.$el.height(windowHeight - 140);
    }
});

export default myw.HelpPanel;
